import React from 'react';
import { Button } from 'baseui/button';
import { FileUploader } from 'baseui/file-uploader';
import useUpload from './useUpload';

const UploadCSV: React.FC = () => {
	const { csvFile, deleteExistingSchema, handleDeleteExistingToggle, handleFileUpload, uploadCsvFile } = useUpload();

	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			<div style={{ width: '500px', height: '200px', border: '1px dashed #ccc', padding: '20px' }}>
				<div style={{ margin: '5px', width: '100%', display: 'flex', alignItems: 'center' }}>
					<label htmlFor='checkbox' style={{ marginLeft: '10px', marginRight: '5px', width: '240px' }}>
						Want to delete existing schema:
					</label>
					<input
						type='checkbox'
						id='checkbox'
						checked={deleteExistingSchema}
						onChange={handleDeleteExistingToggle}
						style={{ transform: 'scale(1.2)', marginTop: '2px' }}
					/>
				</div>
				<FileUploader
					accept={['.csv']}
					onDrop={(uploadedFiles) => handleFileUpload(uploadedFiles)}
					overrides={{
						FileDragAndDrop: {
							style: {
								borderColor: 'purple',
								borderRadius: '10px',
								width: '100%',
								height: '100%'
							}
						}
					}}
				/>
			</div>
			{csvFile && (
				<div style={{ marginTop: '10px', textAlign: 'center' }}>
					<p>File: {csvFile.name}</p>
					<Button
						kind='primary'
						size='compact'
						onClick={uploadCsvFile}
						disabled={!uploadCsvFile}
						overrides={{
							BaseButton: {
								style: {
									width: '100%',
									marginTop: '10px',
									borderRadius: '20px',
									':hover': {
										backgroundColor: 'green'
									},
									':active': {
										backgroundColor: 'green'
									}
								}
							}
						}}>
						Upload
					</Button>
				</div>
			)}
		</div>
	);
};

export default UploadCSV;
